// Narrow a template's flat field array to one signer's fields by signing_order.
// signingOrder == null → return all fields unchanged (backward-compatible default
// for single-signer flows whose fields may not carry a signing_order).
// includeUnordered → also keep fields whose signing_order is null; used by the
// first signer so a legacy/unordered template field is never dropped (the CP
// half absorbs unordered fields; the operator half stays strict to order 2).
export function selectSignerFields(templateFields, signingOrder, options = {}) {
  const { includeUnordered = false } = options;
  const fields = Array.isArray(templateFields) ? templateFields : [];
  if (signingOrder == null) return fields;
  return fields.filter(
    (f) =>
      f.signing_order === signingOrder ||
      (includeUnordered && f.signing_order == null)
  );
}

// A loaded CP link (type 6, or a physician id on a link that isn't a co-sign) is the physician's and a co-sign link (7) the operator's on any route; the route's mode decides the rest.
export function signerFlagsFor(mode, signLink) {
  const type = signLink?.document_type;
  const cpLink = type === 6 || (type !== 7 && signLink?.collab_phys_id != null);
  const isCollabOperator = type === 7 || (!cpLink && mode === "collabOperator");
  const isCp = !isCollabOperator && (cpLink || mode === "collabPhys");
  return { isCp, isCollabOperator };
}

// The CP signs first (signing_order 1), the co-signing operator second (2); signerFlagsFor says which one a link is.
export function signingOrderFor({ isCp, isCollabOperator }) {
  if (isCollabOperator) return 2;
  if (isCp) return 1;
  return null;
}
